import { render, staticRenderFns } from "./PaymentDueReminder.vue?vue&type=template&id=231e7502"
import script from "./PaymentDueReminder.vue?vue&type=script&lang=js"
export * from "./PaymentDueReminder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports